<p>{{ 'help.body' | translate }}</p>
<div class="pt-6 flex flex-col gap-2">
	<ui-button
		class="focus-within:px-1"
		[fullWidth]="true"
		[href]="docsUrl()"
		[text]="'help.open_docs' | translate"
		target="_blank"
		(buttonClicked)="onOpenDocs()"
	></ui-button>
	<ui-button
		class="focus-within:px-1"
		[fullWidth]="true"
		[href]="helpDeskLink"
		[text]="'help.create_ticket' | translate"
		target="_blank"
		type="secondary"
		(buttonClicked)="onCreateTicket()"
	></ui-button>
	<ui-button
		[fullWidth]="true"
		[text]="'general.cancel' | translate"
		type="link"
		(buttonClicked)="onCancel()"
		class="px-1 pb-1"
	></ui-button>
</div>
